/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_PAGES (state, pages) {
    state.pages = pages
  },
  REMOVE_RECORD (state, itemId) {
    const pageIndex = state.pages.findIndex((u) => u.Email === itemId)
    state.pages.splice(pageIndex, 1)
  }
}
